module.exports = __webpack_public_path__ + "img/login123.72dd0a5b.png";